import { render } from "./PersonalTable.vue?vue&type=template&id=db982070"
import script from "./PersonalTable.vue?vue&type=script&lang=js"
export * from "./PersonalTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_d0e91f904bb1d11c0b68168201cc497f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__